<script lang="ts">
	import { cn } from '$lib/utils/class-merge';

	type Props = {
		class?: string;
	};

	let { class: className = '' }: Props = $props();
</script>

<img
	src="/img/logo.png"
	alt="Logo"
	width="55"
	height="55"
	class={cn(
		'~w-[2rem]/[2.7rem] brightness-75 dark:brightness-125 group-hover:brightness-100 transition-colors duration-200 ease-in-out',
		className
	)}
/>
